import React from 'react';
import Lottie from 'lottie-react';
import PopupContainer from '../../../common/components/PopupContainer';
import CustomButton from '../../../common/components/CustomButton';
import { MusicClientContext } from '../../context/MusicClientContext';
import CharaGood from '../../../character/json/chara_good.json';
import { MusicEntity } from '../../types/MusicEntityTypes';
import { showErrorFlush } from '../../../common/form/FrekulForm';

export default function MusicPermissionToUseEditPopup({
  music,
  onCancel,
  onDone,
  onPresentPermissionToUseList,
  onBeginPermissionToUseBulkEdit,
} : {
  music: MusicEntity,
  onCancel: () => void,
  onDone: () => void,
  onPresentPermissionToUseList: () => void,
  onBeginPermissionToUseBulkEdit: () => void,
}) {

  const { savePermissionToUse } = React.useContext(MusicClientContext);

  const handleSubmit = (allowUse: number) => {
    savePermissionToUse(music.id, allowUse).then((responseData) => {
      if (responseData.result) {
        onDone();
      } else {
        showErrorFlush('入力内容に不備があります。');
      }
    });
  };

  return (
    <PopupContainer title="曲の利用許可" onClose={() => { onCancel(); }}>
      <div>
        <div className="list__body">
          <Lottie
            animationData={CharaGood}
            style={{ width: '180px', margin: '-65px auto -18px' }}
          />
          <p>
            この曲を、Frekul以外のサービス・イベント・放送などで使用してもよろしいですか？
            Frekulにお任せいただける場合は「許可する」にご設定ください。
            <CustomButton type="secondary-modal" onClick={() => onPresentPermissionToUseList()}>現在の曲の提供先</CustomButton>
          </p>
          <p className="top_line" />
          <ul>
            <li className="bt">
              <CustomButton type="cancel-split" onClick={() => handleSubmit(0)}>許可しない</CustomButton>
              <CustomButton type="default-split" onClick={() => handleSubmit(1)}>許可する</CustomButton>
            </li>
          </ul>
          <ul className="link_list">
            <li>
              <CustomButton type="secondary-modal" onClick={() => onBeginPermissionToUseBulkEdit()}>利用許可の一括変更</CustomButton>
            </li>
          </ul>
        </div>
      </div>
    </PopupContainer>
  );
}
